import gql from 'graphql-tag';

const LIST_REQUEST_RESPONSE_FILES = gql`
  fragment fileContent on FileContent {
    key
    lastModified
    size
    storageClass
  }

  fragment fileMetadata on FileMetadata {
    nextContinuationToken

    files {
      ...fileContent
    }
  }

  query listRequestAndResponseOnboardingFiles(
    $requestParams: listOnboardingFilesInput!
    $responseParams: listOnboardingFilesInput!
  ) {
    requestFiles: listOnboardingFiles(params: $requestParams) {
      ...fileMetadata
    }

    responseFiles: listOnboardingFiles(params: $responseParams) {
      ...fileMetadata
    }
  }
`;

export default LIST_REQUEST_RESPONSE_FILES;
